import { ApolloClient, InMemoryCache } from '@apollo/client/core';
import possibleTypes from './generated/possibleTypes.json';
import link from './links';
const cache = new InMemoryCache({ possibleTypes });
const apolloClient = new ApolloClient({
    link,
    cache,
    connectToDevTools: window?.location?.hostname === 'localhost',
    queryDeduplication: true,
});
export default apolloClient;
